const translations = {
  "en": {
    "Add": "Add",
    "add assets failed": "add assets failed",
    "Add More Asset": "Add More Asset",
    "Add Others": "Add Others",
    "Crypto": "Crypto",
    "Go on, add more. I'll make sure it all fits perfectly into your strategy, and I'll understand your investment style even better.": "Go on, add more. I'll make sure it all fits perfectly into your strategy, and I'll understand your investment style even better.",
    "Stocks": "Stocks"
  },
  "zh-tw": {
    "Add": "新增",
    "add assets failed": "新增資產失敗",
    "Add More Asset": "新增資產",
    "Add Others": "新增其他",
    "Crypto": "加密貨幣",
    "Go on, add more. I'll make sure it all fits perfectly into your strategy, and I'll understand your investment style even better.": "儘管新增吧！我會將它們無縫融入你的投資策略，更精準掌握你的投資風格。",
    "Stocks": "股票"
  }
};

export default translations;
